import { Bug, RefreshCcw } from 'lucide-react';

import { Empty } from '@/modus/Empty';
import { Button } from '@/ui/Button';
import { cn } from '@/utils/styles';

export type ErrorFallbackProps = {
  root?: boolean;
  error: Error;
};

export function ErrorFallback({ error, root = false }: ErrorFallbackProps) {
  return (
    <div className={cn('size-full flex-1 flex items-center justify-center', root && 'w-screen h-screen')}>
      <Empty.Root className="p-1">
        <Empty.Header>
          <Empty.Media variant="icon">
            <Bug className="size-5" />
          </Empty.Media>
          <Empty.Title>Oops! An error occurred</Empty.Title>
          <Empty.Description>{`${error.name}: ${error.message}`}</Empty.Description>
        </Empty.Header>
        <Empty.Content>
          <Button size="sm" Icon={RefreshCcw} onClick={() => window.location.reload()}>
            Reload Page
          </Button>
        </Empty.Content>
      </Empty.Root>
    </div>
  );
}
